import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RadioOptionCardProps {
  selected: boolean
  onClick: () => void
  children: ReactNode
  align?: 'center' | 'start'
  footer?: ReactNode
}

export function RadioOptionCard({
  selected,
  onClick,
  children,
  align = 'center',
  footer,
}: RadioOptionCardProps) {
  const indicator = (
    <div
      className={cn(
        'flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors',
        align === 'start' && 'mt-0.5',
        selected ? 'border-primary bg-primary' : 'border-muted-foreground/30',
      )}
    >
      {selected && <div className="h-2 w-2 rounded-full bg-white" />}
    </div>
  )

  if (footer !== undefined) {
    return (
      <button
        type="button"
        className={cn(
          'flex w-full cursor-pointer flex-col rounded-lg border text-left transition-colors',
          selected
            ? 'border-primary bg-primary/5 ring-primary/20 ring-1'
            : 'border-border hover:border-primary/50 hover:bg-muted/50',
        )}
        onClick={onClick}
      >
        <div className="flex w-full items-start gap-3 px-4 py-3">
          {indicator}
          {children}
        </div>
        <div className="border-border/50 w-full border-t px-4 py-2">
          {footer}
        </div>
      </button>
    )
  }

  return (
    <button
      type="button"
      className={cn(
        'flex w-full cursor-pointer gap-3 rounded-lg border px-4 py-3 text-left text-sm transition-colors',
        align === 'center' ? 'items-center' : 'items-start',
        selected
          ? 'border-primary bg-primary/5'
          : 'border-border hover:border-primary/50 hover:bg-muted/50',
      )}
      onClick={onClick}
    >
      {indicator}
      {children}
    </button>
  )
}
